import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { Box, CssBaseline, useTheme } from '@mui/material';
import DailyPlant1Log from './DailyPlant1Log/DailyPlant1Log';
import DailyPlant1Curve from './DailyPlant1Curve/DailyPlant1Curve';

function DailyPlant1({SUB_PLANT}) {
    const [key, setKey] = useState('Energy Log');
    const { spacing } = useTheme()
    return (
        <>
            <CssBaseline />
            <Box sx={{ bgcolor: 'background.default', py: spacing(1) }}>
                <Tabs
                    style={{ justifyContent: "flex-start", }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    <Tab eventKey="Energy Log" title="Energy Log">
                    <DailyPlant1Log SUB_PLANT={SUB_PLANT}/>

                    </Tab>

                    <Tab eventKey="Energy Curve" title="Energy Curve">
                    <DailyPlant1Curve SUB_PLANT={SUB_PLANT}/>
                    </Tab>



                </Tabs>
            </Box>
        </>
    )
}

export default DailyPlant1
